import React, { useState } from "react";
import { ArrowUpRight, Users, Zap, Target, Lightbulb } from "lucide-react";
import { CORE_VALUES } from "../lib/data";

const icons = { Users, Zap, Target, Lightbulb };
const positions = [{ x: 50, y: 15 }, { x: 85, y: 50 }, { x: 50, y: 85 }, { x: 15, y: 50 }];

export const CoreValuesOrbit = () => {
  const [active, setActive] = useState(0);
  const value = CORE_VALUES[active];
  const Icon = icons[value.icon];
  return (
    <section className="values-section section-pad" data-testid="core-values-section">
      <div className="container-x">
        <span className="accent-bar mb-3" />
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy">Our Core Values</h2>
        <p className="text-muted-foreground mt-3">The principles that guide every mandate we take on.</p>
        <div className="values-layout">
          <div className="values-orbit" data-testid="values-orbit">
            <div className="orbit-ring" aria-hidden="true" />
            <div className="orbit-hub" data-testid="values-orbit-hub"><span>CREW CONNECT</span><strong>Capital.<br />People.<br />Possibility.</strong></div>
            {CORE_VALUES.map((item, index) => {
              const NodeIcon = icons[item.icon];
              return <button key={item.title} type="button" className={`orbit-node ${active === index ? "is-active" : ""}`} style={{ left: `${positions[index].x}%`, top: `${positions[index].y}%` }} aria-pressed={active === index} aria-controls="value-detail" onClick={() => setActive(index)} title={item.title} data-testid={`value-${index}`}>
                <NodeIcon size={25} aria-hidden="true" /><span>{item.title}</span>
              </button>;
            })}
          </div>
          <div className="value-detail" id="value-detail" aria-live="polite" data-testid="value-detail">
            <span className="value-detail-number" data-testid="value-active-number">0{active + 1} / 04</span>
            <Icon size={38} className="text-brandred my-5" aria-hidden="true" />
            <h3 className="font-heading text-3xl font-bold text-navy" data-testid="value-active-title">{value.title}</h3>
            <p className="text-muted-foreground mt-4 leading-relaxed" data-testid="value-active-description">{value.desc}</p>
            <ArrowUpRight className="mt-6 text-brandred" size={27} aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
};